@layer components {
  .resolved {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    gap: var(--space-3);
    margin-block: calc(-1 * var(--space-2));
  }

  .mark {
    display: grid;
    place-items: center;
    inline-size: 2.5rem;
    block-size: 2.5rem;
    border-radius: var(--radius-blob);
    background: var(--color-surface-sunken);
    color: var(--color-text-muted);
    rotate: -6deg;
  }

  .text {
    display: grid;
    gap: 0.0625rem;
    min-inline-size: 0;
  }

  .title {
    font-size: var(--text-base);
    font-weight: 650;
    font-variant-numeric: tabular-nums;
  }

  .names,
  .source {
    color: var(--color-text-muted);
    font-size: var(--text-sm);
    overflow-wrap: anywhere;
  }

  .link {
    color: var(--color-accent);
    font-weight: 600;
    text-decoration: none;

    @media (hover: hover) {
      &:hover {
        text-decoration: underline;
        text-underline-offset: 0.2em;
      }
    }
  }

  .glyph {
    inline-size: 1.25rem;
    block-size: 1.25rem;
    stroke-width: 2.2;
  }

  .resolved[data-tone="shared"] > .mark,
  .resolved[data-tone="public"] > .mark {
    background: var(--color-accent-soft);
    color: var(--color-accent);
  }

  .resolved[data-tone="public"] > .mark {
    rotate: 6deg;
  }
}
